// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpNuX3 {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  margin: 0 calc(-1 * var(--spacing-3));
  background: var(--surface-neutral-pale, #f4f5f7);
}

.Xm0nyg {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: var(--spacing-0-5);
  min-height: 49px;
  padding: 0 var(--spacing-3);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  background: var(--surface-neutral-white);
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-width: none;
}

.Xm0nyg::-webkit-scrollbar {
  display: none;
}

.x7cteq {
  padding: 15px var(--spacing-1-5) 13px;
  color: var(--text-neutral-stronger);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition:
    color 0.15s,
    border-color 0.15s;
}

.x7cteq:hover,
.x7cteq:focus-visible {
  color: var(--text-primary-medium);
  outline: none;
}

.fV7jMS {
  color: var(--text-primary-medium);
  border-bottom-color: var(--stroke-primary-medium);
  font-weight: var(--font-weight-semibold);
}

.FmFZ3y {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: 32px var(--spacing-3) 48px;
  min-width: 0;
}

@media (max-width: 800px) {
  .kpNuX3 {
    margin-inline: calc(-1 * var(--spacing-2));
  }

  .Xm0nyg,
  .FmFZ3y {
    padding-inline: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Cadastros/CadastrosLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,qDAAqD;EACrD,wCAAwC;EACxC,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,8BAA8B;EAC9B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC;;sBAEoB;AACtB;;AAEA;;EAEE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;;IAEE,gCAAgC;EAClC;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  margin: 0 calc(-1 * var(--spacing-3));\n  background: var(--surface-neutral-pale, #f4f5f7);\n}\n\n.navigation {\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  gap: var(--spacing-0-5);\n  min-height: 49px;\n  padding: 0 var(--spacing-3);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  background: var(--surface-neutral-white);\n  overflow-x: auto;\n  overscroll-behavior-inline: contain;\n  scrollbar-width: none;\n}\n\n.navigation::-webkit-scrollbar {\n  display: none;\n}\n\n.tab {\n  padding: 15px var(--spacing-1-5) 13px;\n  color: var(--text-neutral-stronger);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n  white-space: nowrap;\n  border-bottom: 2px solid transparent;\n  transition:\n    color 0.15s,\n    border-color 0.15s;\n}\n\n.tab:hover,\n.tab:focus-visible {\n  color: var(--text-primary-medium);\n  outline: none;\n}\n\n.tabActive {\n  color: var(--text-primary-medium);\n  border-bottom-color: var(--stroke-primary-medium);\n  font-weight: var(--font-weight-semibold);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: 32px var(--spacing-3) 48px;\n  min-width: 0;\n}\n\n@media (max-width: 800px) {\n  .wrapper {\n    margin-inline: calc(-1 * var(--spacing-2));\n  }\n\n  .navigation,\n  .content {\n    padding-inline: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `kpNuX3`,
	"navigation": `Xm0nyg`,
	"tab": `x7cteq`,
	"tabActive": `fV7jMS`,
	"content": `FmFZ3y`
};
module.exports = ___CSS_LOADER_EXPORT___;
